import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle
} from "@fluentui/react-components";

export type ConfirmationDialogProps = {
  className?: string;
  title: string;
  text?: string;
  open: boolean;
  onDeclineClick: () => void;
  onConfirmClick: () => void;
};

export const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  return (
    <Dialog open={props.open}>
      <DialogSurface className={props.className}>
        <DialogBody>
          <DialogTitle>{props.title}</DialogTitle>
          {props.text && <DialogContent>{props.text}</DialogContent>}
          <DialogActions>
            <Button appearance="secondary" onClick={props.onDeclineClick}>
              Cancel
            </Button>
            <Button appearance="primary" onClick={props.onConfirmClick}>
              Confirm
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  )
}